import React, { Component } from 'react';
import { Icon, Button } from 'antd';
import _ from 'lodash';
import draftToHtml from 'draftjs-to-html';
import ProductContainer from './Container';
import { Image, Spin } from '../../components';
import { withRedux } from '../../hoc';
import { getServiceUrl } from '../../utils';
import { addRecentlyProductAction } from '../../actions/product/products';
import { addWishlistAction, removeWishlistAction } from '../../actions/quotes';

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    product: _.get(state, 'product'),
    quotes: _.get(state, 'quotes')
  };
};

const actions = {
  addRecentlyProductAction,
  addWishlistAction,
  removeWishlistAction
};

@withRedux(mapStateToProps, actions)
export default class ProductDetail extends Component {
  componentDidMount() {
    this.handleRecentlyProducts(this.props.match.params.id);
  }
  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.match.params.id, nextProps.match.params.id)) {
      this.handleRecentlyProducts(nextProps.match.params.id);
    }
  }
  handleRecentlyProducts = id => {
    this.props.actions.addRecentlyProductAction(id);
  };
  handleClickWishlist = id => {
    if (this.alreadyWishlist()) {
      this.props.actions.removeWishlistAction(id);
    } else {
      this.props.actions.addWishlistAction(id);
    }
  };
  alreadyWishlist = () => {
    return _.includes(this.props.quotes.wishlist, _.toInteger(this.props.match.params.id));
  };
  render() {
    const { t } = this.props;
    const id = _.toInteger(_.get(this.props, 'match.params.id'));
    const product = _.get(this.props, `product.products.data.${id}`);
    const productsLoading = _.get(this.props, 'product.products.loading');
    const media_specification_id_data = t(_.get(product, 'media_specification_id_data'));
    const media_full_specification_id_data = t(_.get(product, 'media_full_specification_id_data'));
    const media_catalog_id_data = t(_.get(product, 'media_catalog_id_data'));
    const media_specification_full_file_path = `${getServiceUrl()}/${_.get(media_specification_id_data, 'path')}`;
    const media_full_specification_full_file_path = `${getServiceUrl()}/${_.get(
      media_full_specification_id_data,
      'path'
    )}`;
    const media_catalog_full_file_path = `${getServiceUrl()}/${_.get(media_catalog_id_data, 'path')}`;
    const product_image_full_file_path = `${getServiceUrl()}/${_.get(product, 'image.path')}`;
    const brand_full_file_path = `${getServiceUrl()}/${_.get(product, 'brand.logo.path')}`;
    return (
      <ProductContainer>
        <Spin spinning={productsLoading}>
          <div className="product-detail">
            <div className="main-info">
              <div className="name">{t(_.get(product, 'name'))}</div>
              <div className="image-and-detail">
                <div className="row">
                  <div className="col-md-4">
                    <div className="image">
                      <Image src={product_image_full_file_path} alt={t(_.get(product, 'name'))} />
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="right">
                      <div className="info functions">
                        <div className="title">{t('Product Functions')}:</div>
                        <div
                          className="value"
                          dangerouslySetInnerHTML={{
                            __html: t(_.get(product, 'functions'))
                          }}
                        />
                      </div>
                      <div className="info model">
                        <div className="title">{t('Model')}:</div>
                        <div className="value">{t(_.get(product, 'model'))}</div>
                      </div>
                      <div className="info category">
                        <div className="title">{t('Category')}:</div>
                        <div className="value">{t(_.get(product, 'category.name'))}</div>
                      </div>
                      <div className="info brand">
                        <div className="title">{t('Brand')}:</div>
                        <div className="value">
                          <Image src={brand_full_file_path} alt={t(_.get(product, 'brand.name'))} />
                        </div>
                      </div>
                      <div className="btn-actions-group">
                        <li>
                          <Button
                            className={`wishlist ${this.alreadyWishlist() ? 'active' : ''}`}
                            type="primary"
                            onClick={() => this.handleClickWishlist(id)}
                          >
                            <Icon type="heart" />
                            {t('Request for quotation')}
                          </Button>
                        </li>
                        <li>
                          <a href={media_catalog_full_file_path} target="_blank" download className="left">
                            <Icon type="download" /> {t('Download Catalog')}
                          </a>
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="descriptions">
                <div className="title">{t('Product Descriptions')}:</div>
                <div
                  className="value wysiwyg"
                  dangerouslySetInnerHTML={{
                    __html: draftToHtml(t(_.get(product, 'descriptions')))
                  }}
                />
              </div>
            </div>
            <div className="specification-preview">
              <div className="title">{t('Specification Preview')}</div>
              <div className="value">
                {media_specification_full_file_path && (
                  <a href={media_full_specification_full_file_path} target="_blank">
                    <img src={media_specification_full_file_path} alt={t('Specification Preview')} />
                  </a>
                )}
              </div>
            </div>
            <div className="tips">
              <div className="title">KKC {t('Tips')}:</div>
              <div
                className="value wysiwyg"
                dangerouslySetInnerHTML={{
                  __html: draftToHtml(t(_.get(product, 'tips')))
                }}
              />
            </div>
          </div>
        </Spin>
      </ProductContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Product/ProductDetail.js